var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "router-link",
    {
      staticClass: "sidebar-logo",
      attrs: { to: "/home", "aria-label": "DMPeople" },
    },
    [
      _c("span", { staticClass: "sidebar-logo__frame" }, [
        _c("img", {
          staticClass: "sidebar-logo__horizontal",
          class: { "is-hidden": _vm.collapse },
          attrs: { src: "/logo/dmpeople-horizontal-negativa.svg", alt: "" },
        }),
        _c("img", {
          staticClass: "sidebar-logo__symbol",
          class: { "is-hidden": !_vm.collapse },
          attrs: {
            src: "/logo/dmpeople-simbolo-navy-pontolaranja.svg",
            alt: "",
          },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }